import { MILLISECONDS_IN_MINUTE } from '@stdlib/constants-time';
import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import { message } from 'antd';

import type { IHotelWithDetails } from 'app/typings/migrationTool/HotelWithDetails';
import { apiRequest } from 'app/utils/request/api';

const hotelPath = '/hotels/:hotelId/merge' as const;

export function useGetHotelByParentId(
  hotelId?: number
): UseQueryResult<IHotelWithDetails[], unknown> {
  return useQuery<IHotelWithDetails[]>({
    queryKey: [hotelPath, { hotelId }],
    queryFn: !!hotelId
      ? () =>
          apiRequest({
            path: hotelPath,
            params: { hotelId: hotelId.toString() },
          }).catch((err) => {
            message.error('Error fetching hotel');
            throw err;
          })
      : undefined,
    enabled: !!hotelId,
    staleTime: 5 * MILLISECONDS_IN_MINUTE,
  });
}
